/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './message/get_flags';
import './v2/message/get_flags_v2';
import './message/flag_evaluation_details';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "FlagsService": {
                    "methods": {
                      "GetFlags": {
                        "requestType": ".squareup.feature.relay.flags.message.GetFlagsRequest",
                        "responseType": ".squareup.feature.relay.flags.message.GetFlagsResponse"
                      },
                      "GetDeviceFlags": {
                        "requestType": ".squareup.feature.relay.flags.v2.message.GetDeviceFlagsV2Request",
                        "responseType": ".squareup.feature.relay.flags.v2.message.GetDeviceFlagsV2Response"
                      },
                      "GetAllFlags": {
                        "requestType": ".squareup.feature.relay.flags.v2.message.GetAllFlagsV2Request",
                        "responseType": ".squareup.feature.relay.flags.v2.message.GetAllFlagsV2Response"
                      },
                      "GetAllFlagsUsingTokens": {
                        "requestType": ".squareup.feature.relay.flags.v2.message.GetAllFlagsUsingTokensV2Request",
                        "responseType": ".squareup.feature.relay.flags.v2.message.GetAllFlagsV2Response"
                      },
                      "GetFlagEvaluationDetails": {
                        "requestType": ".squareup.feature.relay.flags.message.FlagEvaluationDetailsRequest",
                        "responseType": ".squareup.feature.relay.flags.message.FlagEvaluationDetailsResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.FlagsService) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE FlagsService @ squareup/feature/relay/flags/service.proto at 15:1
 */
export const FlagsService = $root.lookupService('squareup.feature.relay.flags.FlagsService');
